// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__1M3T8","content":"Consent_content__2ZcPH","footer":"Consent_footer__24Pge"};